export default "<civcast-image-viewer></civcast-image-viewer>\n"